/**
 * @desc 国内电商创建sn
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stockSnDetail.createSn.Params, options?: any) {
  return updateResponse(
    http(URL + `/stockSnDetail/createSn`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
